function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 6.786,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 5.786,
  fill: "#36443A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 12.748a.79.79 0 01-.804-.804.79.79 0 01.804-.803.79.79 0 01.803.803.79.79 0 01-.803.804zM8.357 6.107a.643.643 0 011.286 0v3.429a.643.643 0 01-1.286 0V6.107z",
  fill: "#fff"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS4wMDAwNyIgY3k9IjkuMDAwMDciIHI9IjYuNzg1NzEiIGZpbGw9IndoaXRlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iOS4wMDAwNyIgY3k9IjkuMDAwMDciIHI9IjUuNzg1NzEiIGZpbGw9IiMzNjQ0M0EiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljk5OTg2IDEyLjc0NzhDOC41NDQ1IDEyLjc0NzggOC4xOTYyOSAxMi4zOTk2IDguMTk2MjkgMTEuOTQ0MkM4LjE5NjI5IDExLjQ4ODggOC41NDQ1IDExLjE0MDYgOC45OTk4NiAxMS4xNDA2QzkuNDU1MjIgMTEuMTQwNiA5LjgwMzQzIDExLjQ4ODggOS44MDM0MyAxMS45NDQyQzkuODAzNDMgMTIuMzk5NiA5LjQ1NTIyIDEyLjc0NzggOC45OTk4NiAxMi43NDc4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjM1NzQyIDYuMTA3MjFDOC4zNTc0MiA1Ljc1MjE3IDguNjQ1MjQgNS40NjQzNiA5LjAwMDI4IDUuNDY0MzZDOS4zNTUzMiA1LjQ2NDM2IDkuNjQzMTQgNS43NTIxNyA5LjY0MzE0IDYuMTA3MjFWOS41MzU3OEM5LjY0MzE0IDkuODkwODIgOS4zNTUzMiAxMC4xNzg2IDkuMDAwMjggMTAuMTc4NkM4LjY0NTI0IDEwLjE3ODYgOC4zNTc0MiA5Ljg5MDgyIDguMzU3NDIgOS41MzU3OEw4LjM1NzQyIDYuMTA3MjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgInfo as ReactComponent };